import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CustomButton from 'shared/components/buttons/Custom';
import JobApplicationStatus from 'shared/components/JobApplication/Status';
import Tooltip from 'shared/components/Tooltip';
import { propTypes as jobPropTypes } from 'shared/proptypes/Job';
import { selectors } from 'userportal/ducks/applications';
import { userportal as routes, createRoute } from 'shared/routes';
import styles from './JobApplicationButton.module.scss';

const JobApplicationButton = ({ job, onClick, className, disabledReason }) => {
  const { t } = useTranslation('userportal');
  const navigate = useNavigate();

  const activeApplication = useSelector(state => selectors.getActiveApplicationByJobId(state, job.id));

  if (activeApplication !== null) {
    const detailLink = createRoute(routes.user.application, { jobSlug: activeApplication.job.slug, applicationId: activeApplication.id });
    return (
      <div className={className}>
        <h4 className={styles.titleSmall}>{t('page.job.alreadyApplied')}</h4>
        <div className={styles.applicationPreview}>
          <span><JobApplicationStatus statusId={activeApplication.statusId} /></span>
          <CustomButton iconClassName="la la-arrow-circle-right" onClick={() => navigate(detailLink)}>
            {t('page.job.applicationDetail')}
          </CustomButton>
        </div>
      </div>
    );
  }

  return (
    <Tooltip content={disabledReason}>
      <button
        disabled={!!disabledReason}
        type="button"
        className={cn(styles.button, styles.applyButton, className)}
        onClick={onClick}
      >
        <i className="la la-check-circle" />{t('page.job.applyButton')}
      </button>
    </Tooltip>
  );
};

JobApplicationButton.propTypes = {
  job: PropTypes.shape(jobPropTypes).isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabledReason: PropTypes.string,
};

JobApplicationButton.defaultProps = {
  onClick() {},
  className: null,
  disabledReason: null,
};

export default JobApplicationButton;
